import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {AssignUserEntitlementsResultModal} from './assign-user-entitlements.result.modal';
import {
    clearResult,
    selectAssignUserEntitlementsBulkUuid,
    selectAssignUserEntitlementsShown,
    selectAssignUserEntitlementsTask,
} from './assign-user-entitlements.slice';


export const AssignUserEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectAssignUserEntitlementsBulkUuid}
        actionTaskSelector={selectAssignUserEntitlementsTask}
        actionShownSelector={selectAssignUserEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <AssignUserEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
